import { notification } from 'antd';

export const errHandler = (err) => {
  let error = err;
  if (err != null) {
    if (err.status === 400 || err.status === 500 || err.status === 501 || err.status === 401) {
      error = err.message;
    }
  } else {
    error = "Time out"
  }
  return notification.error({
    message: error,
    duration: 3,
  });
};

export const checkError = (res) => {
  if (res != null && res.status === 200) {
    return res;
  } else {
    return errHandler(res);
  }
}

export const loginSuccess = () =>
  notification.success({
    message: "login Success",
    duration: 3,
  });

export const logouSuccess = () =>
  notification.success({
    message: "logout Success",
    duration: 3,
  });

export const success = ((data) => {
  notification.success({
    message: data,
    duration: 3
  })
});